"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = exports.ConstellationAPIClient = void 0;
const supabase_js_1 = require("@supabase/supabase-js");
const axios_1 = __importStar(require("axios"));
const merge_1 = __importDefault(require("lodash/merge"));
const modules_1 = require("./modules");
class ConstellationAPIClient {
    constructor(options) {
        this.accessToken = null;
        this.options = options;
        this.supabase = (0, supabase_js_1.createClient)(options.servicesUrl, options.servicesAnonKey);
        this.actions = new modules_1.ActionsModule(this);
        this.admin = new modules_1.AdminModule(this);
        this.analytics = new modules_1.AnalyticsModule(this);
        this.appSettings = new modules_1.AppSettingsModule(this);
        this.auth = new modules_1.AuthModule(this);
        this.constellations = new modules_1.ConstellationsModule(this);
        this.feedbackMessages = new modules_1.FeedbackMessagesModule(this);
        this.graphql = new modules_1.GraphQLModule(this);
        this.groups = new modules_1.GroupsModule(this);
        this.iam = new modules_1.IAMModule(this);
        this.icons = new modules_1.IconsModule(this);
        this.notifications = new modules_1.NotificationsModule(this);
        this.novaDecorationImages = new modules_1.NovaDecorationImagesModule(this);
        this.novas = new modules_1.NovasModule(this);
        this.organizationMemberInvitations =
            new modules_1.OrganizationMemberInvitationsModule(this);
        this.organizationMembers = new modules_1.OrganizationMembersModule(this);
        this.organizations = new modules_1.OrganizationsModule(this);
        this.reports = new modules_1.ReportsModule(this);
        this.schedules = new modules_1.SchedulesModule(this);
        this.scheduleTasks = new modules_1.ScheduleTasksModule(this);
        this.search = new modules_1.SearchModule(this);
        this.self = new modules_1.SelfModule(this);
        this.users = new modules_1.UsersModule(this);
        this.supabase.auth.startAutoRefresh();
    }
    generateAxiosConfig() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            // Source the token FRESH from the Supabase session on every request, rather
            // than the token pushed in via setAccessToken(). getSession() returns the
            // current session and refreshes it when it has expired, so the common "token
            // lapsed while the tab was backgrounded" case sends a valid token instead of
            // a stale cached one — the root of the blank-screen-after-inactivity bug (the
            // 403-retry path in executeRequest then re-uses a fresh token too).
            //
            // Precedence: a live session's token wins; otherwise fall back to the token
            // pushed via setAccessToken() — the server-side SDK path (packages/api,
            // packages/admin), which never persists a session. But if getSession() itself
            // ERRORED (a refresh that failed: rotated-out / missing refresh token), the
            // browser session is compromised — send NO token and let executeRequest's 403
            // path refresh-or-sign-out deliberately, rather than papering over a dead
            // session with the expired cached token.
            const { data, error } = yield this.supabase.auth.getSession();
            const token = error
                ? undefined
                : (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : this.accessToken;
            const headers = {};
            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }
            return { headers };
        });
    }
    get(url, config) {
        // create a getter for the result
        const getResult = () => __awaiter(this, void 0, void 0, function* () { return axios_1.default.get(url, (0, merge_1.default)(yield this.generateAxiosConfig(), config !== null && config !== void 0 ? config : {})); });
        // execute the request
        return this.executeRequest(getResult);
    }
    post(url, data, config) {
        // create a getter for the result
        const getResult = () => __awaiter(this, void 0, void 0, function* () {
            return axios_1.default.post(url, data, (0, merge_1.default)(yield this.generateAxiosConfig(), config !== null && config !== void 0 ? config : {}));
        });
        // execute the request
        return this.executeRequest(getResult);
    }
    put(url, data, config) {
        const getResult = () => __awaiter(this, void 0, void 0, function* () {
            return axios_1.default.put(url, data, (0, merge_1.default)(yield this.generateAxiosConfig(), config !== null && config !== void 0 ? config : {}));
        });
        // execute the request
        return this.executeRequest(getResult);
    }
    delete(url, config) {
        // create a getter for the result
        const getResult = () => __awaiter(this, void 0, void 0, function* () { return axios_1.default.delete(url, (0, merge_1.default)(yield this.generateAxiosConfig(), config !== null && config !== void 0 ? config : {})); });
        // execute the request
        return this.executeRequest(getResult);
    }
    /** The API returns 403 for BOTH an invalid/expired session AND a genuine
     *  authorization (permission) failure; executeRequest disambiguates. */
    isForbidden(err) {
        var _a;
        return err instanceof axios_1.AxiosError && ((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 403;
    }
    executeRequest(getResult) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield getResult();
            }
            catch (err) {
                // Only a 403 is recoverable here; anything else propagates untouched.
                if (!this.isForbidden(err))
                    throw err;
                // `generateAxiosConfig` already sent a token sourced from getSession()
                // (refreshed if it had expired), so a 403 is EITHER a session that is dead
                // / revoked server-side OR a genuine permission failure. Force ONE refresh
                // to tell them apart:
                //   - refresh SUCCEEDS → the session is valid; retry once (this recovers a
                //     server-side-revoked token). If it 403s AGAIN, the token is valid and
                //     simply not permitted → propagate as a normal error. Signing the user
                //     out on THIS was the blank-screen bug: a `forbidden` on a valid
                //     session flipped auth state (SIGNED_OUT) and remounted the app.
                //   - refresh FAILS → the session is genuinely dead; sign out cleanly (a
                //     no-op on the server-side SDK path, which has no session) and surface
                //     the original error.
                let session = null;
                try {
                    const { data, error } = yield this.supabase.auth.refreshSession();
                    if (!error)
                        session = data.session;
                }
                catch (_a) {
                    /* refreshSession threw → treat as a dead session (session stays null) */
                }
                if (session) {
                    return yield getResult();
                }
                yield this.supabase.auth.signOut().catch(() => undefined);
                throw err;
            }
        });
    }
    /**
     * Set a FALLBACK access token for API requests. In the browser the live
     * Supabase session takes precedence (see generateAxiosConfig) — this cached
     * value is only used on the server-side SDK path (packages/api, packages/admin)
     * where no session is persisted, or before the first session loads.
     */
    setAccessToken(token) {
        this.accessToken = token;
    }
}
exports.ConstellationAPIClient = ConstellationAPIClient;
const createClient = (options) => {
    return new ConstellationAPIClient(options);
};
exports.createClient = createClient;
